import React, { FC } from 'react';
import ArticlesSection from 'views/chatScreen/articlesSection/ArticlesSection';
import AdminMessages from 'views/chatScreen/adminMessages/AdminMessages';
import Styles from 'views/chatScreen/ChatScreen.module.scss';

interface ArticlesAdminRowProps {
  /** Home / marketing: public APIs, no unread / mark-read. */
  publicMode?: boolean;
}

/** Shared Articles + Admin Messages row used on Dashboard and public Home. */
const ArticlesAdminRow: FC<ArticlesAdminRowProps> = ({ publicMode = false }) => (
  <div className={Styles.topRow}>
    <ArticlesSection publicMode={publicMode} />
    <AdminMessages publicMode={publicMode} />
  </div>
);

export default ArticlesAdminRow;
